<template>
  <div class="container">
    <div class="row">
      <div class="col-md-2">
        <router-link :to="{ name: 'Data Selection' }">
          <div class="btn btn-primary btn-lg elevation-z1">
            <div class="icon"><font-awesome-icon icon="list" /></div>
            <div class="">Data Selection</div>
          </div>
        </router-link>
      </div>

      <div class="col-md-2">
        <router-link :to="{ name: 'Call Campaign' }">
          <div class="btn btn-primary btn-lg elevation-z1">
            <div class="icon"><font-awesome-icon icon="phone" /></div>
            <div class="">Call Campaign</div>
          </div>
        </router-link>
      </div>

      <div class="col-md-2">
        <router-link :to="{ name: 'CreateCompany' }">
          <div class="btn btn-primary btn-lg elevation-z1">
            <div class="icon"><font-awesome-icon icon="plus" /></div>
            <div class="">Create Company</div>
          </div>
        </router-link>
      </div>

      <div class="col-md-2">
        <div class="btn btn-primary btn-lg elevation-z1" @click="openTransfer">
          <div class="icon"><font-awesome-icon icon="exchange" /></div>
          <div class="">Receive Call transfer</div>
        </div>
      </div>

      <div class="col-md-2">
        <router-link :to="{ name: 'MyCallbacks' }">
          <div class="btn btn-primary btn-lg elevation-z1">
            <div class="icon"><font-awesome-icon icon="clock" /></div>
            <div class="">My Callbacks</div>
          </div>
        </router-link>
      </div>

      <div class="col-md-2">
        <router-link :to="{ name: 'Unbooked' }">
        <!-- <router-link :to="{ name: 'Dashboard' }"  > -->
          <div class="btn btn-primary btn-lg elevation-z1">
            <div class="icon"><font-awesome-icon icon="ban" /></div>
            <div class="">Unbooked</div>
          </div>
        </router-link>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2">
        <router-link :to="{ name: 'Search' }">
          <div class="btn btn-primary btn-lg elevation-z1">
            <div class="icon"><font-awesome-icon icon="search" /></div>
            <div class="">Search</div>
          </div>
        </router-link>
      </div>

      <div class="col-md-2">
        <!-- <router-link :to="{ name: 'About' }"> -->
        <router-link :to="{ name: 'Dashboard' }">
          <div class="btn btn-primary btn-lg elevation-z1 disabled">
            <div class="icon"><font-awesome-icon icon="search-plus" /></div>
            <div class="">Admin Search</div>
          </div>
        </router-link>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <b-card title="Callback List">
          

          <b-table
            :items="callbackResults"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :busy.sync="isBusy"
            :tbody-tr-class="rowClass"
          >
            <template v-slot:cell(company)="data">
              {{ data.item.companyName }}<br />
              <font-awesome-icon icon="envelope" /> {{ data.item.postcode
              }}<br />
              <div v-if="data.item.sector">
                <font-awesome-icon icon="tag" /> {{ data.item.sector.name }}
              </div>
            </template>

            <template v-slot:cell(contact)="data">
              <div v-bind:class="{ red: data.item.companyVendors[0].preferredContactNumberCtps }"
                v-if="
                  data.item.companyVendors &&
                  data.item.companyVendors.length > 0
                "
              >
                {{ data.item.companyVendors[0].fullname || `${data.item.companyVendors[0].firstName} ${data.item.companyVendors[0].lastName}`}}
                <br />
                <font-awesome-icon icon="phone" />
                {{ data.item.companyVendors[0].preferredContactNumber }}
              </div>
              <span v-else class="text-muted">No contact available</span>
            </template>

            <template v-slot:cell(callback)="data">
              <div
                v-if="
                  data.item.callbackAttempts && data.item.callbackAttempts > 0
                "
              >
                {{ data.item.lastCallbackDatetime }}
                <br />
                {{ data.item.callbackAttempts }} attempts
              </div>
            </template>

            <template v-slot:cell(priority)="data">
              {{ getDate(data.item.callbackDatetime) }}
              <br />
              {{ data.item.callbackPriority.name }}
            </template>

            <template v-slot:cell(nav)="data">
              <b-button class="btn btn-success btn-sm" block type="button" @click="call(data.item.id)"
                ><font-awesome-icon icon="phone" /> Call</b-button
              >
              <b-button class="btn btn-danger btn-sm" block type="button" @click="release(data.item.id)"
                ><font-awesome-icon icon="times" /> Release</b-button
              >
            </template>
          </b-table>

          <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            first-number
            last-number
          ></b-pagination>
        </b-card>
      </div>
    </div>
    <CompanyTransferRecieveModal ref="companyTransferRecieveModal" />
    <ReleaseCallbackModal ref="releaseCallbackModal" :companyId="selectedCompanyId" :onRelease="loadCallbacks"/>
  </div>
</template>

<script>

import CompanyTransferRecieveModal from "@/components/dashboard/CompanyTransferRecieveModal.vue";
import ReleaseCallbackModal from '@/components/company/dispositions/ReleaseCallbackModal';
import { format, isAfter,parseISO } from "date-fns";
import CompanyService from '@/services/Company.service';

export default {
  name: "Dashboard",
  components: { CompanyTransferRecieveModal, ReleaseCallbackModal },
  data() {
    return {
      currentPage: 1,
      rows: 0,
      isBusy: false,
      perPage: 20,
      sortBy: "",
      sortDesc: false,
      selectedCompanyId: null,
      callbackResults: [],
      fields: [
        { key: "company", label: "Company Name", sortable: false },
        { key: "contact", label: "Primary Contact", sortable: false },
        { key: "callback", label: "Last Contacted", sortable: false },
        {
          key: "priority",
          label: "Callback Arranged/Priority",
          sortable: false,
        },
        { key: "nav", label: "", sortable: false },
      ],
    };
  },
  created() {
    this.loadCallbacks();
  },
  mounted() {
    console.log(this.$parent)
    this.$parent.loadCallbackCount()
  },
  methods: {
    openTransfer() {
      this.$refs.companyTransferRecieveModal.showModal();
    },
    async call(companyId) {
      this.selectedCompanyId = companyId;
      await this.$http.post("/company/lock/" + companyId);
      this.$router.push({ path: "company/" + companyId })
    },
    release(companyId) {
      console.log(companyId)
      this.selectedCompanyId = companyId;
      this.$refs.releaseCallbackModal.showModal();
      this.loadCallbacks();
    },

    getDate(date) {
      return format(new Date(date), "dd/MM/yyyy hh:mm");
    },

    loadCallbacks() {
      CompanyService.getCallbacks().then((response) => {
        this.callbackResults = response.data;
        this.rows = response.data.length;
      });
    },

    rowClass(item, type) {
      if (!item || type !== 'row') return;
      if (isAfter(new Date(), parseISO(item.callbackDatetime))) return 'table-danger'
    }
  },
};
</script>

<style scoped>
.row {
  padding-top: 16px;
}
.btn-primary {
  padding-top: 16px;
  font-size: 0.9em;
  width: 100%;
  height: 100%;
}

.icon {
  font-size: 2em;
}

h2 {
  border-bottom: 1px solid #e5e5e5;
}

.col-md-2 {
  height:112px
}
</style>

